<!--
 * @Author: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @Date: 2024-05-30 14:02:55
 * @LastEditors: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @LastEditTime: 2024-05-30 14:40:54
 * @FilePath: /front-vps-admin/src/pages/admin/user/TableContainer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="table-container" ref="tableContainer">
        <!-- opheader 插槽 -->
        <slot name="opheader"></slot>

        <!-- table 插槽，如果没有指定名称，则为默认插槽 -->
        <div class="table-container-content" ref="tableContainerContent">
            <slot ref="tableContainer_table">
            </slot>
        </div>

        <!-- pagelit 插槽 -->
        <div class="table-container-pagelit">
            <slot name="pagelit"></slot>
        </div>
    </div>
</template>
<script>
const PAGELIT_HEIGHT = 52;      // 分页的高度是52像素
export default {
    data() {
        return {
            containerHeight: 100
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.computeContainerHeight(); // 初始时更新高度  
    },
    methods: {
        handleResize() {
            this.computeContainerHeight();
        },
        computeContainerHeight() {
            this.$nextTick(() => {
                // 确保 DOM 已经更新  
                if (this.$parent) {
                    const parentHeight = this.$parent.$el.clientHeight; // 谨慎使用 $parent  
                    if (this.$refs.tableContainer) {
                        this.$refs.tableContainer.style.height = `${parentHeight}px`;
                    }


                    // 计算头部高度、表格高度、分页高度
                    let tableHeight = parentHeight - 52;
                    if (this.$refs.tableContainerContent)
                        this.$refs.tableContainerContent.style.height = `${tableHeight}px`;
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
.table-container {
    .table-container-pagelit {
        display: flex;
        justify-content: center;
        padding: 10px 0 10px 0;
        align-items: center;
    }
}
</style>